export enum RoleTypeEnum {
  ExecutiveAdmin = 'Executive Admin',
  Coordinator = 'Coordinator',
  CustomerAdmin = 'Customer Admin',
  CustomerCoordinator = 'Customer Coordinator',
  Accounting = 'Accounting',
  Driver = 'Driver',
  Management = 'Management',
  VendorAdmin = 'Vendor Admin',
  VendorCoordinator = 'Vendor Coordinator',
  VendorDriver = 'Vendor Driver',
  InternalReadOnly = 'Internal Read Only',
}
